import { gql } from '@apollo/client';

export const BASIC_USER = gql`
  fragment BasicUserFields on WhatisUser {
    user_id
    uuid
    is_whatis_admin
    is_workspace_admin
    profile_image
    real_name
    title
    points
  }
`;

export const TEAM_USERS = gql`
  ${BASIC_USER}
  fragment TeamUsersFields on Team {
    uuid
    users {
      ...BasicUserFields
    }
  }
`;
